/**
 * Sorter jQuery Plugin
 **/
var Sorter = function(el, options) {
    this.settings = $.extend({}, this.defaults, options);
    this.element = $(el);
    this.bind();
};
 
Sorter.prototype = {
    // shorthand for using prototype
    constructor : Sorter,
    
    // default options
    defaults : {
        effect      : 'none', // none, fade, slide
        afterSort   : null
    },

    element             : null,
    currentlySorted     : {},

    bind : function() {
        var _this = this;
        
        _this.originalSet = [];

        if (_this.element.find('tbody').length) {
            _this.element.find('tbody tr:not(.sort-exclude)').each(function() {
                _this.originalSet.push([0, $(this)]);
            });
        }

        if ($('.sortable', _this.element)) {
            $('.sortable', _this.element).each(function() {
                $(this).append('<span class="sort-icon icon-sort"></span>');
                $(this).on('click', function() {
                    var sortBy = '';

                    if ($(this).find('.sort-icon').hasClass('sort-asc')) {
                        sortBy = 'desc';

                        $('.sort-asc, .sort-desc', _this.element).removeClass('sort-asc').removeClass('sort-desc');
                        $(this).find('.sort-icon').addClass('sort-desc');
                    } else if ($(this).find('.sort-icon').hasClass('sort-desc')) {
                        $('.sort-asc, .sort-desc', _this.element).removeClass('sort-asc').removeClass('sort-desc');
                        $(this).find('.sort-icon');
                    } else {
                        sortBy = 'asc';
                        
                        $('.sort-asc, .sort-desc', _this.element).removeClass('sort-asc').removeClass('sort-desc');

                        $(this).find('.sort-icon').addClass('sort-asc');
                    }

                    var index = $(this).index();

                    if ($(this).attr('data-transpose')) {
                        index = $($(this).attr('data-transpose')).index();
                    } 

                    _this.sort(index, sortBy);
                });
            });
        }
    },

    sort : function(column, sort) {
        var _this = this;
        var rows = _this.element.find('tbody').children(':not(.sort-exclude)');
        var store = [];

        var sortType = _this.element.find('th:eq('+column+')').attr('data-sorting');

        for (var i = 0, len = rows.length; i < len; i++){
            var row = rows[i];

            var sortnr = (row.cells[column].textContent || row.cells[column].innerText);
            
            if ((sortType == "integer" || sortType == "float") && sortnr) {
                sortnr = sortnr.replace('$', '').replace(',', '');

                if (sortType == "integer") {
                    sortnr = sortnr.replace(/[^0-9.]/g, "").split('.')[0];
                } else if (sortType == "float") {
                    sortnr = sortnr.replace(/[^0-9.]/g, '');
                    var sortFloat = parseFloat(sortnr);
                    
                    if (!isNaN(sortFloat)) {
                        sortnr = sortFloat;
                    }
                } 
            }
            if (sortnr || sortnr === 0) {
                store.push([sortnr, row]);
            } else {
                store.push([i, row]);
            }
        }
        
        if ((sort == 'asc') || (sort == 'desc')) {
            _val = ((sort == 'asc') ? '1' : '-1');

            store.sort(function strcmp(a, b) {
                if ((a[0] || a[0] === 0) && (b[0] || b[0] === 0)) {
                    if (sortType == "integer") {
                        a[0] = parseInt(a[0]);
                        b[0] = parseInt(b[0]);
                    } else if (sortType == "float") {
                        a[0] = parseFloat(a[0]);
                        b[0] = parseFloat(b[0]);
                    } else if (sortType == "date") {
                        a[0] = new Date(a[0]);
                        b[0] = new Date(b[0]);
                    } else {
                        if (typeof a[0] != "string") a[0] = '"' + a[0] + '"';
                        if (typeof b[0] != "string") b[0] = '"' + b[0] + '"';

                        a[0] = a[0].toLowerCase();
                        b[0] = b[0].toLowerCase();
                    }

                    if (a[0] < b[0]) {
                        return -1 * _val;
                    } else if (a[0] > b[0]) {
                        return 1 * _val;
                    }
                }
                return 0;
            });
        } else {
            store = _this.originalSet;
        }
        
        var start = _this.element.find('tbody tr:visible:first').index();
        var end = _this.element.find('tbody tr:visible:last').index();  

        _this.element.find('tbody tr:not(.sort-exclude)').remove();
        
        for (var i = 0, len = store.length; i < len; i++){
            _this.element.find('tbody').append(store[i][1]);
        }
        
        _this.element.find('tbody tr').hide();
        _this.element.find('tbody tr').slice(start, end + 1).show();

        if ( $.isFunction(this.settings.afterSort) ) this.settings.afterSort.call( this );

        store = null;
    },

    originalSet : []
};

$.fn.sorter = function ( options ) {
    return this.each(function () {
        if (!$.data(this, 'qg_sorter')) {
            $.data(this, 'qg_sorter', new Sorter( this, options ));
        } 
    });
};